import { createStore } from 'vuex'
import CRM_Auth from "./CRM/Auth";
import CRM_Leads from "./CRM/1.Leads";
import CRM_User from "./CRM/5.User_webcam";
import CRM_Cameras from "./CRM/6.Cameras";
import benefits from "./benefits";
import house_gallery from "./house_gallery";
import amenities_gallery from "./amenities_gallery";
import distance_unit from "./distance_unit";
import expense from "./expense";
import nearby_locations from "./nearby_locations";
import nearby_mini from "./nearby_mini";
import quality_section from "./quality_section";
import rules from "./rules";
import translation from "./translation";
import article from "./article";

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    benefits,
    house_gallery,
    amenities_gallery,
    distance_unit,
    expense,
    nearby_locations,
    nearby_mini,
    quality_section,
    rules,
    translation,
    article,
    CRM_Auth,
    CRM_Leads,
    CRM_User,
    CRM_Cameras,
  }
})
